import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";

export const reportsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    fetchReports: build.query<any, any>({
      query: (params) => {
        const query = params ? new URLSearchParams(params).toString() : "";
        return {
          url: `${API_URLS.REPORTS}${query ? `?${query}` : ""}`,
          method: "GET",
          credentials: "include",
        };
      },
    }),
  }),
});

export const { useFetchReportsQuery } = reportsAPI;
